import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// 1. Import your 8 specific images here
import img1 from "../../../assets/img/portfolio/portfolio-col2-1.jpeg";
import img2 from "../../../assets/img/portfolio/portfolio-col2-2.jpeg";
import img3 from "../../../assets/img/portfolio/portfolio-col2-3.jpeg";
import img4 from "../../../assets/img/portfolio/portfolio-col2-4.jpeg";
import img5 from "../../../assets/img/portfolio/portfolio-col2-5.jpeg";
import img6 from "../../../assets/img/portfolio/portfolio-col2-6.jpeg";
import img7 from "../../../assets/img/portfolio/portfolio-col2-7.jpeg";
import img8 from "../../../assets/img/portfolio/portfolio-col2-8.jpeg";

// 2. Create the custom data array for this specific page
const customPortfolioData = [
    { id: "road-construction", image: img1, title: "Road Construction", subtitle: "Civil Work" },
    { id: "drainage-system", image: img2, title: "Base development", subtitle: "Infrastructure" },
    { id: "pipeline-setup", image: img3, title: "Pipeline Setup", subtitle: "Public Utility" },
    { id: "rcc-road", image: img4, title: "Door setup", subtitle: "Civil Work" },
    { id: "irrigation-line", image: img5, title: "Irrigation Line", subtitle: "Agriculture" },
    { id: "damar-road", image: img6, title: "Drainage Repair", subtitle: "Infrastructure" },
    { id: "beautification", image: img7, title: "Water management", subtitle: "Urban Development" },
    { id: "renovation", image: img8, title: "Renovation", subtitle: "Public Utility" }
];

const showPortfolioItem = 4;

const TwoColumns = () => {
    // 3. Load the custom array into the state
    const [items, setItems] = useState(customPortfolioData);
    const [next, setNext] = useState(showPortfolioItem);
    
    const handleLoadData = () => {
        setNext(value => value + 2); // Loads 2 more images per click
    }

    return (
        <div className="two__columns section-padding-three">
            <div className="container">
                <div className="row">
                    {items?.slice(0, next)?.map((data, id) => (
                        <div className="col-md-6 mt-25" key={id}>
                            <div className="portfolio__two-item">
                                <img src={data.image} alt={data.title} style={{ width: '100%', height: '400px', objectFit: 'cover' }} />
                                <div className="portfolio__two-item-content">
                                    <span>{data.subtitle}</span>
                                    <h4><Link to={`/portfolio/${data.id}`}>{data.title}</Link></h4>
                                    <Link to={`/portfolio/${data.id}`}><i className="flaticon-right-up"></i></Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {next < items.length && (
                    <div className="row mt-70">
                        <div className="col-xl-12 t-center">
                            <button onClick={handleLoadData} className="build_button">Load More <i className="flaticon-right-up"></i></button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TwoColumns;